export default "/_next/static/chunks/fonts/Montserrat-BlackItalic-latin-174700090df87e13a916060d23bad642.woff2";